var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"order-item"},[_c('div',{staticClass:"order-item-item order-item-quantity"},[_vm._v(_vm._s(_vm.line.quantity))]),_vm._v(" "),_c('div',{staticClass:"order-item-item order-item-name"},[_vm._v(_vm._s(_vm.line.description))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-231af06a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/lines/Line.vue
// module id = 118
// module chunks = 0